var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4deb91c2bb1c539e69d1f3b771665d6f94d70ba9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sv-hero-web@socialvenu"]={id:"4deb91c2bb1c539e69d1f3b771665d6f94d70ba9"};
      